/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type MODERATION_MODE = "POST" | "PRE" | "SPECIFIC_SITES_PRE" | "%future added value";
export type CreateCommentReplyMutation_story = {
    readonly url: string;
    readonly settings: {
        readonly moderation: MODERATION_MODE;
    };
    readonly " $refType": "CreateCommentReplyMutation_story";
};
export type CreateCommentReplyMutation_story$data = CreateCommentReplyMutation_story;
export type CreateCommentReplyMutation_story$key = {
    readonly " $data"?: CreateCommentReplyMutation_story$data;
    readonly " $fragmentRefs": FragmentRefs<"CreateCommentReplyMutation_story">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCommentReplyMutation_story",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "url",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "StorySettings",
            "kind": "LinkedField",
            "name": "settings",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "moderation",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "Story",
    "abstractKey": null
} as any);
(node as any).hash = '18c52306486b3ba27fea5dfc638c316c';
export default node;
